<div class="service-tile__status__flex">
  @for (state of indicators() | keys | slice: 0 : 3; track state) {
    <div class="service-tile__status">
      <svg-icon
        src="assets/images/icons/status-{{ state | status_to_icon }}.svg"
        class="service-tile__status__icon service-tile__status__icon--{{ colors[state] }}"
        [class.service-tile__status__icon--gray]="indicators()[state] === 0"
        matTooltip="{{ statusKey(state) | translate }}"
        [matTooltipPosition]="'above'"
      ></svg-icon>
      <div class="service-tile__status__number">{{ indicators()[state] }}</div>
    </div>
  }
</div>
